import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import moment from 'moment';
import * as actions from '../../../../../redux/projects/actions.projects';
import platformNames from '../../../../../const/platformNames';
import PopupWrapper from '../../../../components/Popup/PopupWrapper';
import Menu from '../../../../components/Menu/Menu';
import asyncDispatch from '../../../../../services/mini/asyncDispatch';
import CohortForm from '../CohortForm/CohortForm';
import formats from '../../../../../const/formats';
import { confirmAlert } from '../../../../../services/mini/alanConfirmAlert';
import ConfirmPopup from '../../../../components/ConfirmPopup/ConfirmPopup';
import NoCohortView from '../NoCohortView/NoCohortView';
import { EMBED_TRANSITION_TIME } from '../../EmbedCodeForm/EmbedCodeForm';


class CohortsForm extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            ...this.fillState(props)
        };

        this.control = React.createRef();
        this.getCohortsInterval = null;
    }

    componentDidMount() {
        const { getCohorts, projectId } = this.props;
        setTimeout(() => {
            const inputEl = this.control.current?.querySelector('input');
            if (inputEl) {
                inputEl.focus();
            }
        }, EMBED_TRANSITION_TIME);

        this.getCohortsInterval = setInterval(() => {
            getCohorts({ projectId });
        }, 10000);
    }

    componentDidUpdate(prevProps) {
        const curCohort = this.state.cohort;
        const updatedState = this.fillState(this.props);

        if (curCohort?.currentNumberOfDevices !== updatedState.cohort?.currentNumberOfDevices) {
            this.setState({ ...updatedState });
        }
    }

    componentWillUnmount() {
        clearInterval(this.getCohortsInterval);
    }

    fillState = (props) => {
        const { cohorts, selectedCohortId } = props;

        let cohort = _.find(cohorts, { id: selectedCohortId });

        if (!cohort && cohorts.length > 0) {
            cohort = cohorts[0];
        }

        return {
            selectedCohortId: cohort ? cohort.id : null,
            cohort,
            saving: false
        };
    }

    createCohort = () => {
        const { createCohort, project, environment, cohorts } = this.props;

        this.setState({ saving: true }, () => {
            createCohort({
                project, environment, cohorts
            }).then((cohort) => {
                this.setState({
                    selectedCohortId: cohort.id,
                    cohort: cohort,
                    saving: false
                });
            });
        });
    }

    deleteCohort = (cohort) => {
        const { deleteCohort, projectId, environment, onCohortDeleted } = this.props;

        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <ConfirmPopup
                        onClose={onClose}
                        okBtnLabel="Delete"
                        okBtnCb={() => {
                            if (cohort.id === this.props.selectedCohortId) {
                                onCohortDeleted();
                            }
                            deleteCohort({
                                cohort,
                                projectId,
                                environment
                            }).then((cohorts) => {
                                if (cohorts.length > 0) {
                                    const firstCohort = cohorts[0];
                                    this.setState({
                                        selectedCohortId: firstCohort.id,
                                        cohort: firstCohort
                                    });
                                } else {
                                    this.setState({
                                        selectedCohortId: null,
                                        cohort: null
                                    });
                                }
                            });
                            onClose();
                        }}
                        type="delete"
                        title="Delete Cohort"
                        message={`Are you sure you want to delete “${cohort.name}” cohort?`} />
                );
            }
        });
    }

    selectCohort = (cohort) => {
        this.props.onCohortSelected(cohort);
    }

    render() {
        const {
            projectId,
            environment,
            onClose,
            cohorts
        } = this.props;

        const { cohort, selectedCohortId, saving } = this.state;

        return <PopupWrapper className="cohorts-form">
            <div className="cohorts-form_external-wrapper"
                ref={this.control}>
                <div className="popup-form_header popup-form_header_with-commands">
                    <div className="popup-form_header_cmd"
                        onClick={onClose}>
                        <i className="icon icon-alan-chevron"
                            style={{
                                transform: 'rotate(90deg)',
                                display: 'inline-block',
                                marginRight: '5px'
                            }} />
                        Back
                    </div>
                    <div>Cohorts Details</div>
                    <div className="popup-form_header_cmd" />
                </div>
                <div className="popup-form_internal-wrapper cohorts-form_internal-wrapper">
                    <div className="cohorts-form_content">
                        <div className="cohorts-form_left-part">
                            <div className={`cohorts-form_left-part_add-cohort ${saving && 'disabled'}`}
                                onClick={this.createCohort}>
                                Create new cohort <i className="icon icon-alan-plus-stroked" />
                            </div>
                            <div className="cohorts-form_left-part_list">
                                <div className="cohorts-form_left-part_list_header">
                                    Cohorts
                                </div>
                                <div className="cohorts-form_left-part_list_cohorts">
                                    {[...cohorts]
                                        .reverse()
                                        .map(curCohort => {
                                            const selected = curCohort.id === selectedCohortId;
                                            return <div
                                                key={`${curCohort.id}-${selectedCohortId}`}
                                                onClick={() => { this.selectCohort(curCohort); }}//todo: move to separate component
                                                className={`cohort-left-part-list-item ${selected && 'selected'}`}>
                                                <div className="cohort-left-part-list-item_info">
                                                    <div className="cohort-left-part-list-item_name">{curCohort.name}</div>
                                                    <div className="cohort-left-part-list-item_ts"></div>{moment(+curCohort.updateTs).format(formats.MMM_DD_hh_mm_a)}
                                                </div>
                                                <Menu>
                                                    {React.Children.toArray(
                                                        <div onClick={() => { this.deleteCohort(curCohort); }}>
                                                            Delete
                                                    </div>
                                                    )}
                                                </Menu>
                                            </div>;
                                        })}
                                </div>
                            </div>
                        </div>
                        <div className="cohorts-form_right-part">
                            {
                                (cohorts.length > 0 && cohort) ?
                                    <CohortForm
                                        key={`${cohort.id}-${+cohort.updateTs}`}
                                        cohorts={cohorts}
                                        cohort={cohort}
                                        projectId={projectId}
                                        environment={environment} /> :
                                    <NoCohortView createCohort={this.createCohort} />
                            }
                        </div>
                    </div>
                </div>
            </div>
        </PopupWrapper>;
    }
}

function mapStateToProps({ projectsInfo }) {
    return {
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getCohorts: (param) => asyncDispatch(actions.getCohorts, dispatch, param),
        createCohort: (param) => asyncDispatch(actions.createCohort, dispatch, param),
        deleteCohort: (param) => asyncDispatch(actions.deleteCohort, dispatch, param),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(CohortsForm);
